import { useState } from "react";
import { Calendar } from "primereact/calendar";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

const CalendarHighlight = ({ markedDates = [], setMonth, setYear }) => {
  const markedDays = new Set(markedDates.map((date) => date.split("T")[0]));
  
  const [viewDate, setViewDate] = useState(new Date());

  const dateTemplate = (dateMeta) => {
    const formattedDate =
      dateMeta.year +
      "-" +
      (dateMeta.month + 1).toString().padStart(2, "0") +
      "-" +
      dateMeta.day.toString().padStart(2, "0");
    const isMarked = markedDays.has(formattedDate);

    return (
      <div
        className={`p-datepicker-day ${isMarked ? "marked" : ""}`}
        style={{
          backgroundColor: isMarked ? "#6A6AD8" : "transparent",
          color: isMarked ? "white" : "",
          borderRadius: "50%",
          width: '50px',
          padding: "9px",
          textAlign: 'center'
        }}
      >
        {dateMeta.day}
      </div>
    );
  };

  const handleViewDateChange = (e) => {
    const newDate = e.value;
    setViewDate(newDate);
    setMonth(newDate.getMonth() + 1);
    setYear(newDate.getFullYear());
  };

  return (
    <Calendar
      inline
      locale="es"
      viewDate={viewDate}
      onViewDateChange={handleViewDateChange} 
      dateTemplate={dateTemplate}
    />
  );
};

export default CalendarHighlight;
